import React from 'react';
import PropTypes from 'prop-types';
import Modal from '../Modal/Modal';
import DhabiIcon from '../Icons/DhabiIcon';

export default function StudentPopup(props) {
  const {
    message,
    buttonTextConfirm,
    title,
    iconClassNames,
    onClickConfirm,
    buttonTextCancel,
    onClickCancel,
    isRTL,
    testId,
  } = props;

  return (
    <Modal testId={testId}>
      <div className={`popup__dialog ${isRTL ? 'rtl' : ''}`}>
        <div className="popup__content">
          <DhabiIcon
            size={150}
            className="popup__image"
            alt="Gazelle"
            data-testid="popup-image"
          />
          {iconClassNames && (
            <i
              className={`popup__icon icon icon--${iconClassNames}`}
              data-testid="popup-icon"
            />
          )}
          <div className="popup__info">
            <h1 className="popup__title">{title}</h1>
            <p className="popup__message usprivacy" dir="ltr">
              {message}
            </p>
            <div className="popup__buttons">
              {buttonTextCancel && (
                <button
                  data-testid={'popup-cancel-button'}
                  className="popup__button popup__button--cancel"
                  onClick={onClickCancel}
                >
                  {buttonTextCancel}
                </button>
              )}
              {buttonTextConfirm && (
                <button
                  data-testid={'popup-confirm-button'}
                  className="popup__button popup__button--confirm"
                  onClick={onClickConfirm}
                >
                  {buttonTextConfirm}
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
}

StudentPopup.defaultProps = {
  iconClassNames: null,
  onClickCancel: () => {},
  buttonTextCancel: '',
  isRTL: false,
  buttonTextConfirm: '',
  testId: undefined,
};

StudentPopup.propTypes = {
  iconClassNames: PropTypes.string,
  message: PropTypes.string.isRequired,
  onClickConfirm: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  buttonTextConfirm: PropTypes.string,
  testId: PropTypes.string,
  buttonTextCancel: PropTypes.string,
  onClickCancel: PropTypes.func,
  isRTL: PropTypes.bool,
};
